import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { memo, useCallback, useContext, useEffect, useMemo, useRef, useState, } from 'react';
import styleUtils from '../../styles/styleUtils';
import { Tooltip } from '../Tooltip';
import { customColorSwatchImage } from './customColorSwatchImage';
import { SwatchPickerContext } from './SwatchPickerContext';
import { SwatchPickerDesign } from './SwatchPickerDesign';
import { useSwatchStyles } from './useSwatchStyles';
const customColorImageUrl = `'data:image/svg+xml;utf8,${encodeURIComponent(customColorSwatchImage)}'`;
const swatchDisplayName = 'Custom color';
const defaultTooltipMinWidth = 175;
const swatchContainerStyles = css `
  position: relative;
`;
const tooltipContainerStyles = css `
  align-items: center;
  display: flex;
`;
const tooltipStyles = css `
  display: inline-flex;
`;
const defaultProps = {
    tooltipMinWidth: defaultTooltipMinWidth,
    tooltipText: 'Additional custom colors available.',
};
const CustomColorSwatch = ({ onClick, tooltipMinWidth = defaultProps.tooltipMinWidth, tooltipText = defaultProps.tooltipText, }) => {
    const { shape, size, } = useContext(SwatchPickerContext);
    const swatchStyles = useSwatchStyles({
        isDisabled: false,
        isSelected: false,
        shape,
        size,
    });
    const [isTooltipVisible, setIsTooltipVisible,] = useState(false);
    const swatchRef = useRef(null);
    const onCustomColorClick = useCallback((event) => {
        if (onClick) {
            onClick(event);
        }
        else {
            setIsTooltipVisible((localIsTooltipVisible) => (!localIsTooltipVisible));
        }
    }, [
        onClick,
    ]);
    const customColorStyles = useMemo(() => (css `
        ${styleUtils.buttonReset}
        ${swatchStyles}
        background-color: transparent;

        &:active,
        &:hover,
        &:focus {
          border-color: transparent;
          outline: none;
        }
      `), [
        swatchStyles,
    ]);
    const onSecondaryClick = useCallback((event) => {
        if (swatchRef.current
            && !swatchRef.current.contains(event.target)) {
            setIsTooltipVisible(false);
        }
    }, []);
    useEffect(() => {
        if (typeof document === 'undefined'
            || !Boolean(onClick)) {
            return;
        }
        if (isTooltipVisible) {
            document.addEventListener('mousedown', onSecondaryClick);
        }
        else {
            document.removeEventListener('mousedown', onSecondaryClick);
        }
        return () => {
            document.removeEventListener('mousedown', onSecondaryClick);
        };
    }, [
        isTooltipVisible,
        onClick,
        onSecondaryClick,
    ]);
    return (_jsx("div", Object.assign({ css: swatchContainerStyles, ref: swatchRef }, { children: _jsxs("div", Object.assign({ css: tooltipContainerStyles }, { children: [_jsx("button", Object.assign({ "aria-label": swatchDisplayName, css: customColorStyles, "data-test-ref": "swatch-custom-color-button", onClick: onCustomColorClick, title: swatchDisplayName, type: "button" }, { children: _jsx(SwatchPickerDesign, { imageUrl: customColorImageUrl }) })), _jsx("div", Object.assign({ css: tooltipStyles }, { children: _jsx(Tooltip, Object.assign({ alignContent: "center", enterDelay: true, exitDelay: true, minWidth: tooltipMinWidth, placement: "bottom", showTooltip: isTooltipVisible }, { children: tooltipText })) }))] })) })));
};
const MemoizedCustomColorSwatch = memo(CustomColorSwatch);
export { MemoizedCustomColorSwatch as CustomColorSwatch };
// MC-1068 Temporary hack for Storybook.
export default CustomColorSwatch;
